export default {
  analysis: 'Análisis',
  communication: 'Comunicación',
  creativity: 'Creatividad',
  flexibility: 'Flexibilidad',
  initiative: 'Iniciativa',
  leadership: 'Liderazgo',
  criticalThinking: 'Pensamiento crítico',
  perseverance: 'Perseverancia',
  resilience: 'Resiliencia',
  responsibility: 'Responsabilidad',
  problemResolution: 'Resolución de problemas',
  teamwork: 'Trabajo en equipo'
}

export const en = {
  analysis: 'Analysis',
  communication: 'Communication',
  creativity: 'Creativity',
  flexibility: 'Flexibility',
  initiative: 'Initiative',
  leadership: 'Leadership',
  criticalThinking: 'Critical Thinking',
  perseverance: 'Perseverance',
  resilience: 'Resilience',
  responsibility: 'Responsibility',
  problemResolution: 'Problem solving',
  teamwork: 'Teamwork'
}

export const ca = {
  analysis: 'Anàlisi',
  communication: 'Comunicació',
  creativity: 'Creativitat',
  flexibility: 'Flexibilitat',
  initiative: 'Iniciativa',
  leadership: 'Lideratge',
  criticalThinking: 'Pensament crític',
  perseverance: 'Perseverança',
  resilience: 'Resiliència',
  responsibility: 'Responsabilidad',
  problemResolution: 'Resolució de problemes',
  teamwork: 'Treball en equip'
}
